(function () {
  'use strict';

  if (window.__ultimaXcloudPolish) return;
  window.__ultimaXcloudPolish = true;

  /* Marked before the app injects anything so the stylesheet can hide the
     control block until placeSearchFilters() has a container to put it in. */
  if (isSearchResults()) document.documentElement.classList.add('ultima-xsearch');

  var syncQueued = false;
  var busyStartedAt = 0;
  var busyLastSignalAt = 0;
  var busyHref = '';
  var busyHasSignal = false;
  var busyHasStrongSignal = false;
  var busyCheckTimer = null;
  var busyShowTimer = null;
  var busyOverlay = null;
  var resultsEntryTimer = null;
  var busyPositionQueued = false;
  var busyStorageKey = 'ultima-xcloud-filter-update';
  var searchReloadKey = 'ultima-xsearch-reload';
  var searchSidebarPending = false;
  var searchSidebarAttempts = 0;
  var searchSidebarHref = '';

  function resultsSurfaces() {
    return document.querySelectorAll('.cloud-search-filters-products, .ultima-col__grid');
  }

  /* The loader belongs to the grid, not the viewport. Anchor it just inside the
     top of the results, then let it stick near the top of the screen once that
     edge scrolls away, so it stays visible without ever becoming a centred
     modal. Written as custom properties; the CSS owns the centring transform. */
  function positionBusyOverlay() {
    if (!busyOverlay) return;

    var surface = document.querySelector('.cloud-search-filters-products, .ultima-col__grid');
    if (!surface) return;

    var rect = surface.getBoundingClientRect();
    if (!rect.width && !rect.height) return;

    var halfWidth = (busyOverlay.offsetWidth || 170) / 2;
    var x = Math.min(
      Math.max(rect.left + rect.width / 2, halfWidth + 12),
      Math.max(window.innerWidth - halfWidth - 12, halfWidth + 12)
    );

    var y = Math.max(rect.top + 30, 78);
    y = Math.min(y, Math.max(rect.bottom - 30, 78));
    y = Math.min(y, window.innerHeight - 44);

    busyOverlay.style.setProperty('--ux-loader-x', Math.round(x) + 'px');
    busyOverlay.style.setProperty('--ux-loader-y', Math.round(y) + 'px');
  }

  function scheduleBusyPosition() {
    if (busyPositionQueued) return;
    if (!busyOverlay || !busyOverlay.classList.contains('is-visible')) return;
    busyPositionQueued = true;
    window.requestAnimationFrame(function () {
      busyPositionQueued = false;
      positionBusyOverlay();
    });
  }

  function ensureBusyOverlay() {
    if (busyOverlay && document.documentElement.contains(busyOverlay)) return busyOverlay;
    if (!document.body) return null;

    busyOverlay = document.createElement('div');
    busyOverlay.className = 'ultima-xcloud-filter-loader';
    busyOverlay.setAttribute('role', 'status');
    busyOverlay.setAttribute('aria-live', 'polite');

    var mark = document.createElement('span');
    mark.className = 'ultima-xcloud-filter-loader__mark';
    mark.setAttribute('aria-hidden', 'true');

    var label = document.createElement('strong');
    label.className = 'ultima-xcloud-filter-loader__label';
    label.textContent = 'Updating cards';

    busyOverlay.appendChild(mark);
    busyOverlay.appendChild(label);
    document.body.appendChild(busyOverlay);
    return busyOverlay;
  }

  function persistBusyState(active) {
    try {
      if (active) window.sessionStorage.setItem(busyStorageKey, String(Date.now()));
      else window.sessionStorage.removeItem(busyStorageKey);
    } catch (error) {}
  }

  function setResultsBusy(active) {
    resultsSurfaces().forEach(function (surface) {
      if (active) surface.setAttribute('aria-busy', 'true');
      else surface.removeAttribute('aria-busy');
    });
  }

  function revealUpdatedResults() {
    if (resultsEntryTimer) window.clearTimeout(resultsEntryTimer);
    var surfaces = resultsSurfaces();
    surfaces.forEach(function (surface) {
      surface.classList.remove('ultima-xcloud-results-entering');
      void surface.offsetWidth;
      surface.classList.add('ultima-xcloud-results-entering');
    });
    resultsEntryTimer = window.setTimeout(function () {
      surfaces.forEach(function (surface) {
        surface.classList.remove('ultima-xcloud-results-entering');
      });
    }, 520);
  }

  function finishBusyState() {
    if (!busyStartedAt) return;

    busyStartedAt = 0;
    busyLastSignalAt = 0;
    busyHref = '';
    busyHasSignal = false;
    busyHasStrongSignal = false;
    if (busyCheckTimer) window.clearTimeout(busyCheckTimer);
    if (busyShowTimer) window.clearTimeout(busyShowTimer);
    busyCheckTimer = null;
    busyShowTimer = null;
    persistBusyState(false);
    document.documentElement.classList.remove('ultima-xcloud-filter-busy');
    setResultsBusy(false);
    revealUpdatedResults();

    if (!busyOverlay) return;
    busyOverlay.classList.add('is-leaving');
    window.setTimeout(function () {
      if (!busyOverlay) return;
      busyOverlay.classList.remove('is-visible', 'is-leaving');
    }, 220);
  }

  function markBusySignal(strong) {
    if (!busyStartedAt) return;
    busyHasSignal = true;
    if (strong) busyHasStrongSignal = true;
    busyLastSignalAt = Date.now();
  }

  function appIsReloading() {
    return !!document.querySelector('.cloud-search-reloading');
  }

  function checkBusyState() {
    busyCheckTimer = null;
    if (!busyStartedAt) return;

    var now = Date.now();
    var elapsed = now - busyStartedAt;
    var reloading = appIsReloading();
    if (window.location.href !== busyHref) {
      busyHref = window.location.href;
      markBusySignal(false);
    }
    if (reloading) markBusySignal(true);

    var quietFor = now - (busyLastSignalAt || busyStartedAt);
    var strongCycleSettled = busyHasStrongSignal && !reloading && quietFor >= 240 && elapsed >= 620;
    var weakCycleTimedOut = busyHasSignal && !busyHasStrongSignal && elapsed >= 1800;
    var actionWasNoop = !busyHasSignal && elapsed >= 1350;

    if (strongCycleSettled || weakCycleTimedOut || actionWasNoop || elapsed >= 10000) {
      finishBusyState();
      return;
    }

    busyCheckTimer = window.setTimeout(checkBusyState, 100);
  }

  function beginBusyState() {
    if (document.documentElement.classList.contains('ultima-xcloud-resetting')) return;

    if (!busyStartedAt) {
      busyStartedAt = Date.now();
      busyHref = window.location.href;
      busyHasSignal = false;
      busyHasStrongSignal = false;
      busyLastSignalAt = busyStartedAt;
      persistBusyState(true);
      document.documentElement.classList.add('ultima-xcloud-filter-busy');
      setResultsBusy(true);
    }

    if (!busyShowTimer && !(busyOverlay && busyOverlay.classList.contains('is-visible'))) {
      busyShowTimer = window.setTimeout(function () {
        busyShowTimer = null;
        if (!busyStartedAt) return;
        var overlay = ensureBusyOverlay();
        if (!overlay) return;
        overlay.classList.remove('is-leaving');
        positionBusyOverlay();
        window.requestAnimationFrame(function () {
          overlay.classList.add('is-visible');
        });
      }, 140);
    }

    if (busyCheckTimer) window.clearTimeout(busyCheckTimer);
    busyCheckTimer = window.setTimeout(checkBusyState, 100);
  }

  function mutationTouchesResults(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : null;
    if (mutation.type === 'attributes') {
      return !!(target && target.matches('.cloud-search-reloading'));
    }
    if (target && (target.matches('.cloud-search-reloading, .cloud-search-filters-products, .ultima-col__grid') ||
        target.closest('.cloud-search-filters-products, .ultima-col__grid'))) return true;

    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      if (!node || node.nodeType !== 1) return false;
      return node.matches('.cloud-search-reloading, .cloud-search-filters-products, .ultima-col__grid') ||
        !!node.querySelector('.cloud-search-filters-products, .ultima-col__grid');
    });
  }

  function isProxyCollection() {
    return /^\/a\/search\/[^/]+\/?$/.test(window.location.pathname);
  }

  /* The text-query results page, as opposed to /a/search/<handle>. */
  function isSearchResults() {
    if (!/^\/a\/search\/?$/.test(window.location.pathname)) return false;
    return new URL(window.location.href).searchParams.has('q');
  }

  /* XCloud historically built `.cloud-search-filters-sidebar-container` on
     collection proxy routes. Some storefront responses now use the same
     horizontal/mobile control block as text search instead. Detect that exact
     response shape and opt it into the synthetic-sidebar path below. */
  function proxyNeedsSidebarFallback() {
    if (!isProxyCollection()) return false;
    if (document.documentElement.classList.contains('ultima-xproxy-fallback')) return true;

    var root = document.getElementById('cloud_search_filters_root');
    if (!root || !root.querySelector('.cloud-search-page-controls--collection-page')) return false;

    return !document.querySelector('.cloud-search-filters-sidebar-container');
  }

  function placeProxyFilters() {
    if (!proxyNeedsSidebarFallback()) return;

    var root = document.getElementById('cloud_search_filters_root');
    var collection = document.querySelector('#shopify-section-main .collection');
    if (!root || !collection) return;

    document.documentElement.classList.add('ultima-xproxy-fallback');

    /* Use Impact's existing `.container` as the grid. Re-parenting the entire
       `.collection` subtree disconnects and reconnects its custom elements;
       Impact's connectedCallback then observes a child that no longer exists
       and throws an IntersectionObserver TypeError. Inserting one plain side
       node beside the collection produces the same layout without reconnecting
       any theme components. */
    var layout = collection.parentNode;
    if (!layout || !layout.classList) return;
    if (!layout.classList.contains('ultima-xproxy__layout')) {
      layout.classList.add('ultima-xproxy__layout');
    }

    var mount = layout.querySelector('.ultima-xproxy__side');
    if (!mount) {
      var side = document.createElement('div');
      side.className = 'ultima-xproxy__side';
      layout.insertBefore(side, collection);
      mount = side;
    }

    if (mount && root.parentNode !== mount) mount.insertBefore(root, mount.firstChild);
    ensureSearchSidebar(mount);
  }

  /* XCloud gives the search results page its horizontal control block, never
     the sidebar it builds for collection proxy pages, and appends it as the
     first child of <main> — above the page title, outside the container that
     holds the grid. Every result refresh replaces that container and re-appends
     the block, so this runs on each sync rather than once. Section 11 of the
     stylesheet keeps the unadopted copy hidden, so no pass paints in the wrong
     place. */
  function placeSearchFilters() {
    if (!isSearchResults()) return;

    var root = document.getElementById('cloud_search_filters_root');
    var collection = document.querySelector('#shopify-section-main .collection');
    if (!root || !collection) return;

    /* Use Impact's existing container as the grid, just as the collection
       fallback does. Wrapping and re-parenting `.collection` reconnects the
       theme's custom elements and makes FacetFloatingFilter observe a missing
       child, producing an IntersectionObserver exception on every search. */
    var layout = collection.parentNode;
    if (!layout || !layout.classList) return;
    layout.classList.add('ultima-xsearch__layout');

    var side = layout.querySelector('.ultima-xsearch__side');
    if (!side) {
      side = document.createElement('div');
      side.className = 'ultima-xsearch__side';
      layout.insertBefore(side, collection);
    }

    var mount = side;
    if (mount && root.parentNode !== mount) mount.appendChild(root);
    ensureSearchSidebar(mount);
  }

  /* ---- Expanded filter groups on the search page --------------------------
     Read the "EXPANDED GROUPS COST A RELOAD" note at the head of section 11 of
     ultima-xcloud-filters.css before changing any of this. In short: XCloud
     only ever assembles expanded groups inside its slide-out pane, and only
     after the Filter trigger is used, so the trigger is pressed once per
     document and the column is moved into a mount that mirrors the collection
     sidebar's markup. Re-parenting that subtree means XCloud's next in-place
     rebuild produces an empty shell, so a URL change is answered with a
     document reload rather than an empty column. Desktop only. */

  function searchSidebarWanted() {
    if (isSearchResults()) return window.innerWidth >= 1000;
    return document.documentElement.classList.contains('ultima-xproxy-fallback') &&
      isProxyCollection() && window.innerWidth >= 1000;
  }

  function buildSearchSidebarMount(side) {
    var mount = document.createElement('div');
    mount.id = 'cloud_search_filters_sidebar';
    side.appendChild(mount);
    return mount;
  }

  /* Guarded so a URL XCloud keeps rewriting can never loop the document. */
  function reloadForSearchSidebar() {
    var href = window.location.href;
    try {
      var last = window.sessionStorage.getItem(searchReloadKey);
      if (last) {
        var parts = last.split('\n');
        if (parts[0] === href && Date.now() - Number(parts[1]) < 10000) return;
      }
      window.sessionStorage.setItem(searchReloadKey, href + '\n' + Date.now());
    } catch (error) {}

    searchSidebarHref = '';
    beginBusyState();
    persistBusyState(true);
    window.location.reload();
  }

  function ensureSearchSidebar(side) {
    if (!side) return;

    /* The pane's real nodes are adopted into the desktop column. Put them back
       when a window crosses into the mobile/tablet layout so the drawer keeps
       working without a reload. */
    if (!searchSidebarWanted()) {
      var existingMount = side.querySelector('#cloud_search_filters_sidebar');
      var existingInner = existingMount && existingMount.querySelector('.cloud-search-filters-sidebar');
      var existingPane = document.querySelector('.cloud-search-filters-pane');
      if (existingInner && existingPane) {
        Array.prototype.slice.call(existingInner.children).forEach(function (node) {
          if (!node.classList.contains('ultima-xcloud-generated-apply')) existingPane.appendChild(node);
        });
        existingMount.remove();
        searchSidebarHref = '';
        searchSidebarAttempts = 0;
        searchSidebarPending = false;
      }
      return;
    }

    var mount = side.querySelector('#cloud_search_filters_sidebar');
    var populated = !!(mount && mount.querySelector('.cloud-search-filter'));

    /* The column is only ever correct for the URL it was adopted under. */
    if (searchSidebarHref && searchSidebarHref !== window.location.href) {
      reloadForSearchSidebar();
      return;
    }
    if (populated) {
      searchSidebarAttempts = 0;
      return;
    }

    var pane = document.querySelector('.cloud-search-filters-pane');
    var column = pane && pane.querySelector('.cloud-search-filters-column');
    if (column) {
      if (!mount) mount = buildSearchSidebarMount(side);
      var inner = mount.querySelector('.cloud-search-filters-sidebar');
      if (!inner) {
        inner = document.createElement('div');
        inner.className = 'cloud-search-filters-sidebar';
        mount.appendChild(inner);
      }

      /* The pane and the collection sidebar are the same five parts under two
         sets of names — heading, applied filters, clear-all, separator, column.
         Carrying the whole set over and adding the sidebar's own class to each
         is what makes sections 2-5 style this page identically, and it keeps
         "Clear all filters" and the applied chips, which the collection sidebar
         also shows. */
      Array.prototype.slice.call(pane.children).forEach(function (node) {
        if (node.classList.contains('cloud-search-filters-pane__close')) return;
        ['heading', 'applied-filters', 'separator'].forEach(function (part) {
          if (node.classList.contains('cloud-search-filters-pane__' + part)) {
            node.classList.add('cloud-search-filters-sidebar__' + part);
          }
        });
        if (node.classList.contains('cloud-search-filters-column')) {
          node.classList.add('cloud-search-filters-sidebar__filters');
        }
        inner.appendChild(node);
      });
      /* Opening the pane sets the scroll lock even though it never paints. */
      document.documentElement.classList.remove('ultima-xcloud-filters-open');
      if (document.body) document.body.classList.remove('ultima-xcloud-filters-open');
      ensureSyntheticApply(inner);
      searchSidebarHref = window.location.href;
      searchSidebarAttempts = 0;
      searchSidebarPending = false;
      return;
    }

    /* A result set with no filters at all must not retrigger forever. */
    if (searchSidebarPending || searchSidebarAttempts >= 4) return;
    var trigger = side.querySelector('.cloud-search-page-controls__filters-link');
    if (!trigger) return;

    /* Built empty so `#cloud_search_filters_sidebar:empty` shows the branded
       skeleton while XCloud assembles the groups. */
    if (!mount) buildSearchSidebarMount(side);
    searchSidebarPending = true;
    searchSidebarAttempts += 1;
    trigger.click();
    window.setTimeout(function () {
      searchSidebarPending = false;
      ensureSearchSidebar(document.querySelector('.ultima-xsearch__side, .ultima-xproxy__side'));
    }, 350);
  }


  function normalizedText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function cloudsearchFacets() {
    var data = document.getElementById('cloudsearch-data');
    if (!data) return [];
    try {
      var parsed = JSON.parse(data.textContent || '{}');
      return Array.isArray(parsed.facets) ? parsed.facets : [];
    } catch (error) {
      return [];
    }
  }

  function syntheticFiltersActive() {
    return isSearchResults() || proxyNeedsSidebarFallback();
  }

  function groupForFacet(container, facet) {
    if (!container || !facet) return null;
    return Array.prototype.find.call(
      container.querySelectorAll('.cloud-search-filter'),
      function (group) {
        return normalizedText(group.getAttribute('data-filter-name')) === normalizedText(facet.name);
      }
    ) || null;
  }

  function clearFacetParams(params, id) {
    var base = 'filter_' + id;
    Array.from(params.keys()).forEach(function (key) {
      if (key === base || key.indexOf(base + '[') === 0) params.delete(key);
    });
  }

  function selectedFacetRows(group) {
    return Array.prototype.filter.call(
      group.querySelectorAll('.cloud-search-filter-value[data-filter-value]'),
      function (row) {
        return row.classList.contains('cloud-search-filter-value--selected') ||
          !!row.querySelector('input:checked');
      }
    );
  }

  function selectedFacetValues(group) {
    return selectedFacetRows(group).map(function (row) {
      return row.getAttribute('data-filter-value');
    }).filter(function (value, index, values) {
      return value !== null && values.indexOf(value) === index;
    });
  }

  function setFacetValues(params, facet, values) {
    clearFacetParams(params, facet.id);
    if (!values.length) return;
    var base = 'filter_' + facet.id;
    if (values.length === 1) {
      params.set(base, values[0]);
      return;
    }
    values.forEach(function (value, index) {
      params.set(base + '[' + index + ']', value);
    });
  }

  /* XCloud's current storefront build can update the checkbox presentation
     without submitting the pane or an adopted sidebar. Serialize the same
     facet shape its own client uses and navigate to the canonical proxy URL. */
  function syntheticFiltersUrl(container) {
    var next = new URL(window.location.href);
    var params = next.searchParams;
    params.delete('page');

    cloudsearchFacets().forEach(function (facet) {
      var group = groupForFacet(container, facet);
      if (!group) return;

      if (facet.type === 'sort') {
        var selectedSort = selectedFacetRows(group)[0];
        if (selectedSort) params.set('sort_by', selectedSort.getAttribute('data-filter-value'));
        return;
      }

      clearFacetParams(params, facet.id);

      if (facet.type === 'availability') {
        if (group.querySelector('.cloud-search-filter-value--selected, input:checked')) {
          params.set('filter_' + facet.id + '[in_stock]', 'true');
        }
        return;
      }

      if (facet.type === 'price' || facet.type === 'range') {
        var min = group.querySelector('input[aria-label="Min price"], .cloud-search-num-field__input:first-of-type');
        var max = group.querySelector('input[aria-label="Max price"], .cloud-search-num-field__input:last-of-type');
        if (min && String(min.value).trim() !== '') {
          params.set('filter_' + facet.id + '[min]', String(min.value).trim());
        }
        if (max && String(max.value).trim() !== '') {
          params.set('filter_' + facet.id + '[max]', String(max.value).trim());
        }
        return;
      }

      if (facet.type === 'search') {
        var query = group.querySelector('.cloud-search-text-field__input:not(.cloud-search-text-field__input--value-search)');
        if (query && String(query.value).trim() !== '') {
          params.set('filter_' + facet.id, String(query.value).trim());
        }
        return;
      }

      setFacetValues(params, facet, selectedFacetValues(group));
    });

    return next.href;
  }

  function navigateWithSyntheticFilters(container) {
    if (!container) return;
    beginBusyState();
    persistBusyState(true);
    window.location.assign(syntheticFiltersUrl(container));
  }

  function ensureSyntheticApply(container) {
    if (!container || !syntheticFiltersActive()) return;
    if (container.querySelector('.cloud-search-filters-apply')) return;

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'cloud-search-filters-apply ultima-xcloud-generated-apply';
    apply.textContent = 'View results';
    container.appendChild(apply);
  }

  function formatPrice(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return value;
    return number.toLocaleString('en-CA', {
      minimumFractionDigits: number % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function syncPriceState() {
    if (!isProxyCollection()) return;

    var params = new URL(window.location.href).searchParams;
    var min = params.get('filter_price[min]');
    var max = params.get('filter_price[max]');

    if (min !== null) {
      document.querySelectorAll('input[aria-label="Min price"]').forEach(function (input) {
        if (input.value !== min) input.value = min;
      });
    }

    if (max !== null) {
      document.querySelectorAll('input[aria-label="Max price"]').forEach(function (input) {
        if (input.value !== max) input.value = max;
      });
    }

    if (min === null && max === null) return;

    var range = '';
    if (min !== null && max !== null) range = '$' + formatPrice(min) + ' – $' + formatPrice(max);
    else if (min !== null) range = '$' + formatPrice(min) + '+';
    else range = 'Up to $' + formatPrice(max);

    document.querySelectorAll('.cloud-search-applied-filter, .cloud-search-applied-filter--rounded').forEach(function (chip) {
      if (!/^price\b/i.test(normalizedText(chip.textContent))) return;
      var value = chip.querySelector('.cloud-search-applied-filter__values');
      if (value && normalizedText(value.textContent) !== range) value.textContent = range;
      chip.setAttribute('aria-label', 'Price: ' + range + '. Remove filter');
    });
  }

  function repairAccessibleNames() {
    document.querySelectorAll('.cloud-search-filters-products .product-card__image--secondary').forEach(function (image) {
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
    });

    document.querySelectorAll('main h1').forEach(function (heading) {
      var text = normalizedText(heading.textContent);
      if (!text || text.length % 2) return;
      var midpoint = text.length / 2;
      var first = normalizedText(text.slice(0, midpoint));
      var second = normalizedText(text.slice(midpoint));
      if (first && first.toLowerCase() === second.toLowerCase()) heading.setAttribute('aria-label', first);
    });

    document.querySelectorAll('.cloud-search-filters-pane__close').forEach(function (close) {
      if (!close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close filters');
      if (!/^(BUTTON|A)$/.test(close.tagName)) {
        close.setAttribute('role', 'button');
        close.setAttribute('tabindex', '0');
      }
    });

    compactMobilePane();
  }

  /* The app expands every drawer group, making the nine-option Sort group fill
     most of the first screen and nesting several small scrollers inside the
     drawer. Turn the mobile pane into a compact accordion: Availability stays
     open, selected groups stay open, and the remaining groups can be expanded
     from accessible headings. The app still owns every option and submission. */
  function compactMobilePane() {
    if (window.innerWidth >= 1000) return;

    document.querySelectorAll('.cloud-search-filters-pane .cloud-search-filter').forEach(function (filter) {
      var heading = filter.querySelector('.cloud-search-filter__name');
      if (!heading) return;

      var name = normalizedText(filter.getAttribute('data-filter-name') || heading.textContent);
      var selected = filter.querySelector('.cloud-search-filter-value--selected, input:checked');
      var priceSelected = false;
      if (name === 'Price') {
        try {
          var params = new URL(window.location.href).searchParams;
          priceSelected = params.has('filter_price[min]') || params.has('filter_price[max]');
        } catch (error) {}
      }
      var shouldCollapse = name === 'Sort by' ||
        (name !== 'Availability' && !selected && !priceSelected);

      if (!filter.dataset.ultimaCompactGroup) {
        filter.dataset.ultimaCompactGroup = 'true';
        filter.classList.toggle('ultima-xcloud-group-collapsed', shouldCollapse);
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');

        var toggle = function (event) {
          if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          var collapsed = filter.classList.toggle('ultima-xcloud-group-collapsed');
          heading.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        };

        heading.addEventListener('click', toggle, true);
        heading.addEventListener('keydown', toggle, true);
      }

      heading.setAttribute(
        'aria-expanded',
        filter.classList.contains('ultima-xcloud-group-collapsed') ? 'false' : 'true'
      );

      if (name === 'Sort by') {
        var selectedSort = filter.querySelector('.cloud-search-filter-value--selected .cloud-search-filter-value__name');
        var current = heading.querySelector('.ultima-xcloud-sort-current');
        if (!current) {
          current = document.createElement('span');
          current.className = 'ultima-xcloud-sort-current';
          heading.appendChild(current);
        }
        current.textContent = selectedSort ? normalizedText(selectedSort.textContent) : '';
      }
    });

    document.querySelectorAll('.cloud-search-filters-pane').forEach(ensureSyntheticApply);
  }

  function sync() {
    syncQueued = false;
    placeSearchFilters();
    placeProxyFilters();
    syncPriceState();
    repairAccessibleNames();
  }

  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(sync);
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('.cloud-search-filters-apply');
    if (!apply || !syntheticFiltersActive()) return;
    var container = apply.closest(
      '.cloud-search-filters-pane, #cloud_search_filters_sidebar, .cloud-search-filters-sidebar'
    );
    if (!container) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    navigateWithSyntheticFilters(container);
  }, true);

  /* Some XCloud builds update the drawer state but fail to submit its Apply
     control. Re-use the mirrored sidebar Apply action only when the first
     action demonstrably left the URL and drawer unchanged. */
  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('.cloud-search-filters-pane .cloud-search-filters-apply');
    if (!apply || apply.dataset.ultimaFallbackPending) return;

    var before = window.location.href;
    apply.dataset.ultimaFallbackPending = 'true';

    window.setTimeout(function () {
      delete apply.dataset.ultimaFallbackPending;
      var pane = apply.closest('.cloud-search-filters-pane');
      var paneStyle = pane ? window.getComputedStyle(pane) : null;
      var paneStillOpen = pane && paneStyle.visibility !== 'hidden' && pane.getBoundingClientRect().width > 0;
      if (window.location.href !== before || !paneStillOpen) return;

      var sidebarApply = document.querySelector('#cloud_search_filters_sidebar .cloud-search-filters-apply');
      if (sidebarApply && sidebarApply !== apply) sidebarApply.click();
    }, 700);
  }, true);

  /* Start one consistent transition for every action that can refresh the
     result set. Drawer values are exempt while they are only being staged;
     their Apply button owns the actual loading cycle. */
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(
      '.cloud-search-filters-apply, .cloud-search-applied-filter, .cloud-search-applied-filter--rounded, .cloud-search-filter-value a[href]'
    );
    if (!target || target.closest('.cloud-search-clear-filters')) return;
    var stagingPane = target.closest('.cloud-search-filters-pane');
    if (target.matches('.cloud-search-filter-value a[href]') &&
        stagingPane && stagingPane.querySelector('.cloud-search-filters-apply')) return;
    beginBusyState();
  }, true);

  document.addEventListener('pointerup', function (event) {
    var range = event.target.closest && event.target.closest('.cloud-search-range-slider');
    if (!range) return;
    var pane = range.closest('.cloud-search-filters-pane');
    if (pane && pane.querySelector('.cloud-search-filters-apply')) return;
    beginBusyState();
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches) return;
    if (input.matches('.cloud-search-text-field__input--value-search')) return;

    var updatesResults = input.matches(
      'input[name="sort_by"], .cloud-search-filter-value input, .cloud-search-num-field__input, input[aria-label="Min price"], input[aria-label="Max price"], .cloud-search-range-slider input, .cloud-search-filter select'
    );
    if (!updatesResults) return;

    var pane = input.closest('.cloud-search-filters-pane');
    if (pane && pane.querySelector('.cloud-search-filters-apply') && input.name !== 'sort_by') return;
    beginBusyState();
  }, true);

  document.addEventListener('keydown', function (event) {
    var close = event.target.closest && event.target.closest('.cloud-search-filters-pane__close');
    if (!close || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    close.click();
  });

  window.addEventListener('scroll', scheduleBusyPosition, { passive: true });
  window.addEventListener('resize', function () {
    scheduleBusyPosition();
    scheduleSync();
  }, { passive: true });

  var observer = new MutationObserver(function (mutations) {
    scheduleSync();
    if (!busyStartedAt) return;
    scheduleBusyPosition();
    if (mutations.some(mutationTouchesResults)) markBusySignal(true);
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  window.addEventListener('popstate', function () {
    beginBusyState();
    markBusySignal(false);
    scheduleSync();
  });

  function initialSync() {
    var storedAt = 0;
    try { storedAt = Number(window.sessionStorage.getItem(busyStorageKey)); } catch (error) {}
    /* isSearchResults() carries the loader across the reload the search
       sidebar needs; XCloud has not injected its root this early. */
    if (storedAt > 0 && Date.now() - storedAt < 15000 &&
        (isProxyCollection() || isSearchResults() ||
         document.getElementById('cloud_search_filters_root'))) {
      beginBusyState();
      markBusySignal(false);
    } else {
      persistBusyState(false);
    }
    scheduleSync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialSync, { once: true });
  else initialSync();
})();
